import { FYW_URLS } from "../helpers/api/API_URLS";
import { basicFILEPOST, basicGET, basicJSONPOST } from "../helpers/api/fetchParams";

export async function getRetailers(manufacturer, token) {
    try {
        const response = await fetch(FYW_URLS.listRetailers+"/"+manufacturer, basicGET(token));
        if (!response.ok) {
            const message = 'An error has occured: '+response.status;
            throw new Error(message);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.log(error);
    }
}

export async function saveRetailer(body) {
    var token = localStorage.getItem("token");
    const response = await fetch(FYW_URLS.retailer, basicJSONPOST(token, body));
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function saveLocation(body) {
    var token = localStorage.getItem("token");
    const response = await fetch(FYW_URLS.location, basicJSONPOST(token, body));
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function saveLogo(id, logo) {
    var token = localStorage.getItem("token");
    const response = await fetch(FYW_URLS.API+"nfa/retailer/"+id+"/logo", basicFILEPOST(token, logo, "POST"));
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}


// WEBPACK FOOTER //
// ./src/data/serviceLeadgen.js